var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-improving-large.16e04c4a.png","uri@2x": __webpack_public_path__ + "icon-improving-large.f936c772.png","uri@3x": __webpack_public_path__ + "icon-improving-large.30eba1bd.png",
    width: 100,
    height: 100
});